import { useState, useEffect } from 'react';
import { API } from './index';

// 管理员列表Hook
const useAdminList = () => {
  const [adminList, setAdminList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAdminList = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await API.get('/api/admin/users/admins');
      const { success, data, message } = res.data;
      if (success) {
        setAdminList(data || []);
      } else {
        setError(message || '获取管理员列表失败');
        setAdminList([]);
      }
    } catch (error) {
      setError(error.message || '网络错误');
      setAdminList([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadAdminList();
  }, []);

  // 根据ID查找管理员信息
  const findAdminById = (id) => {
    return adminList.find(admin => admin.id === id);
  };

  // 获取管理员显示名称
  const getAdminDisplayName = (id) => {
    const admin = findAdminById(id);
    return admin ? admin.username : `管理员 ${id}`;
  };

  // 获取管理员完整信息
  const getAdminFullInfo = (id) => {
    const admin = findAdminById(id);
    return admin ? `${admin.username} (${admin.email})` : `管理员 ${id}`;
  };

  // 转换为Select组件的options格式
  const getAdminOptions = (includeUnassign = true) => {
    const options = adminList.map(admin => ({
      key: admin.id,
      text: `${admin.username} (${admin.email})`,
      value: admin.id
    }));

    if (includeUnassign) {
      options.unshift({ key: 'unassign', text: '取消分配', value: 0 });
    }

    return options;
  };

  // 转换为筛选用的options格式
  const getFilterOptions = () => {
    const options = [
      { key: 'all', text: '全部', value: '' },
      { key: 'unassigned', text: '未分配', value: '0' }
    ];

    adminList.forEach(admin => {
      options.push({
        key: admin.id,
        text: admin.username,
        value: admin.id.toString()
      });
    });

    return options;
  };

  return {
    adminList,
    loading,
    error,
    loadAdminList,
    findAdminById,
    getAdminDisplayName,
    getAdminFullInfo,
    getAdminOptions,
    getFilterOptions
  };
};

export default useAdminList;
